import { render, staticRenderFns } from "./CompetitionsView.vue?vue&type=template&id=e48593ae&scoped=true&"
import script from "./CompetitionsView.vue?vue&type=script&lang=js&"
export * from "./CompetitionsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48593ae",
  null
  
)

export default component.exports